module.exports = __webpack_public_path__ + "static/media/KaTeX_Fraktur-Bold.1aca7ef7.woff";